import React, { useState } from "react";
import RejectionResponse from "../subChildren/RejectionResponse";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { approvedNotCatelogue } from "../../../../../../redux/action/catalogue";

function RejectionReason({ onRejectResponseId }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [collectResponse, setCollectResponse] = useState("");

  const sendResponse = () => {
    dispatch(
      approvedNotCatelogue(id, onRejectResponseId, { message: collectResponse })
    );
  };

  return (
    <div className="">
      {onRejectResponseId && (
        <div
          className="cover white p-1"
          style={{ width: "99%", margin: "auto" }}
        >
          <div className="gap-10px">
            <RejectionResponse
              collectResponse={collectResponse}
              setCollectResponse={setCollectResponse}
              onSubmit={sendResponse}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default RejectionReason;
